export default "__VITE_ASSET__B3L_D9Ey__"